<template>
	<b-modal id="exam-questions-modal" :dialog-class="'animate-modal-dialog '+(isExpanded?'expanded':'shrink')" @change="$emit('updateModalState', false)" :visible="visible" hide-header centered
		content-class="exam-questions-modal" size="xl" body-class="modal-body" hide-footer modal-class="custom-modal"
		no-close-on-backdrop>
		<div class="body-container">
			<div class="right-close-panel">
				<button @click="()=>{ isExpanded=!isExpanded; }" class="close-button expanded-btn mr-3" role="button">
							<i v-if="!isExpanded" class="fas fa-expand-alt"></i>
							<i v-if="isExpanded" class="fas fa-compress-alt"></i>
				</button>
				<button @click="$emit('updateModalState', false)" class="close-button" role="button">
				<img src="@/assets/images/cancel-icon.svg" />
				</button>
			</div>
			
		</div>
		<div  >
			<div v-if="this.iframeURL">
				<h6 class="load-head" > <b-spinner ></b-spinner> Loading...</h6>
				<iframe :src="this.iframeURL" class="modal-iframe">
			
				</iframe>
			</div>
			<div v-if="!this.iframeURL"  class="modal-iframe">
				<!-- <Loading /> -->
			</div>

		</div>
	</b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LegacyExam } from "../../../constants/exam";
import Loading from "../../../components/Layout/Loading.vue";

export default {
	name: "ExamQuestionsModal",
	props: {
		visible: Boolean,
		item:Object,
        mode:String
	},
	data() {
		return {
			iframeURL:null,
			isExpanded:false
		};
	},
	methods: {
		...mapActions("content", ["getContentById"]),
		handleLegacyExamActions(action) {
			this.iframeURL=null;
			this.getContentById({
				id: this.item.id,
				extraParams: { action: action },
			}).then((content) => {
				if (content ) {
					var examActionUrl = content.data.redirectUrl;

          if(this.isAppleDevice()) {
            window.open(
                examActionUrl,
                "_blank"
            );

            this.$emit('updateModalState', false, null)
          } else {
            this.iframeURL=examActionUrl;
          }

					return;
				}
			});
		},
    isAppleDevice() {
      const userAgent = navigator.userAgent;

      return /Mac|Macintosh|iPhone|iPad/.test(userAgent);
    }
	},
	components: {
		Loading,
		LegacyExam
	},
	created(){
	},
	computed: {	
	},
	watch: {
		visible: function () {
			if (this.visible) {
				if (!this.mode || this.mode.toLowerCase() == "list")
					this.handleLegacyExamActions(LegacyExam.GET_EXAM_ACTION.LIST_QUESTION);
				if (this.mode && this.mode.toLowerCase() == "create")
					this.handleLegacyExamActions(LegacyExam.GET_EXAM_ACTION.CREATE_QUESTION);
			}
		},
	},
};
</script>

<style scoped>
	.right-close-panel
	{
		position: absolute;
    	top: 2.5rem;
    	right: 2rem;
		display: flex;
	}

	.right-close-panel .close-button
	{
		position: initial;
	}
	
	.expanded-btn{
		color: black;
	    font-size: 24px;
	    margin-right: 15px;
		padding-top: 4px;
	}
</style>
<style>
.exam-questions-modal {
	min-height: 45.375rem;
	width: 100vw;
	position: relative;
}


#exam-questions-modal .expanded
{
	max-width: 96%;
	max-height: 96%;

}

#exam-questions-modal .expanded .exam-questions-modal
{
	height: 90vh;
	
}



/* .custom-modal .modal-dialog {
	max-width: 70vw;
} */
.load-head{
	position: absolute;
}

.exam-questions-modal .modal-body {
	padding: 0 !important;
	font-size: 1rem;
	min-height: 43rem;
}

.exam-questions-modal .modal-body .modal-iframe {
	width: 100%;
	position:absolute;
	height: 100%;
}


.exam-questions-modal .body-container {
	display: flex;
	flex-direction: column;
	padding: 2.5rem 2.5rem 1.5rem;
    position: absolute;
    z-index: 999999;
    right: 0;

}


.exam-questions-modal .body-container .header {
	display: flex;
	justify-content: space-between;
	margin-right: 30px;

}

.create-meeting-modal .exam-questions-title {
	font-weight: 450;
	font-size: 2rem;
	line-height: 0.75;
	margin: 0.5rem 0 2rem;
	color: #000000;
}
</style>
